<template>
  <section class="headSection main-filter">
    <form
      @submit.prevent
      class="w-100 d-flex justify-content-between align-items-center flex-wrap"
    >
      <div class="frm-controls w-100 p-0">
        <div class="col-md-3" v-if="withSearch">
          <div class="input_wrapper top_label">
            <label for="searchInput" class="form-label">{{
              searchLabel || "بحث عن"
            }}</label>
            <v-text-field
              id="searchInput"
              prepend-icon="mdi-magnify"
              v-model="frmData.searchInput"
              @change="setKeyWord($event, 'keyword'), getResult"
            ></v-text-field>
          </div>
        </div>

        <div
          class="categories col-sm-3 col-md-4 col-xxl-3"
          v-if="place_categories.length"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.place_category_id"
              :options="place_categories"
              label="name"
              track-by="name"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.placeCategory") }}
            </label>
          </div>
        </div>

        <div class="col-md-3" v-if="meals_name">
          <div class="input_wrapper top_label">
            <label for="searchInput" class="form-label">{{
              searchLabel || "اسم الوجبة"
            }}</label>
            <v-text-field
              id="meals_name"
              prepend-icon="mdi-magnify"
              v-model="frmData.meals_name"
              @change="setMealName($event, 'name'), getResult"
            ></v-text-field>
          </div>
        </div>

        <div class="categories col-sm-3 col-md-4 col-xxl-3" v-if="numberSeats">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label">عدد المقاعد</label>
              <v-text-field
                id="searchInput"
                type="number"
                prepend-icon="mdi-magnify"
                v-model="frmData.number_seats"
                @input="getResult"
              ></v-text-field>
            </div>
          </div>
        </div>

        <div
          class="categories col-sm-3 col-md-4 col-xxl-3"
          v-if="orderStatuses.length"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.status"
              :options="orderStatuses"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.status") }}
            </label>
          </div>
        </div>

        <div
          class="categories col-sm-3 col-md-4 col-xxl-3"
          v-if="providers.length"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.provider"
              :options="providers"
              label="text"
              track-by="value"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ providers_title }}
            </label>
          </div>
        </div>

        <div class="categories col-sm-3 col-md-4 col-xxl-3" v-if="numberDoors">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label">عدد الابواب</label>
              <v-text-field
                id="searchInput"
                type="number"
                prepend-icon="mdi-magnify"
                v-model="frmData.number_doors"
                @input="getResult"
              ></v-text-field>
            </div>
          </div>
        </div>

        <div class="date col-sm-3 col-md-4 col-xxl-3" v-if="madeAt">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label"> تاريخ الصنع </label>
              <v-menu
                ref="dateMadeModal"
                v-model="dateMadeModal"
                :close-on-content-click="false"
                :return-value.sync="frmData.dateMade"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- multiple
                  chips
                  small-chips -->
                  <v-combobox
                    v-model="frmData.dateMade"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <!-- multiple -->
                <v-date-picker
                  @input="
                    getResult();
                    dateMadeModal = false;
                    $refs.dateMadeModal.save(frmData.dateMade);
                  "
                  v-model="frmData.dateMade"
                  no-title
                  scrollable
                >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      frmData.dateMade = '';
                      $refs.dateMadeModal.save(frmData.dateMade);
                      dateMadeModal = false;
                      getResult();
                    "
                  >
                    الغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>

        <div class="date col-sm-3 col-md-4 col-xxl-3" v-if="dateStart">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label">
                {{ from_title }}
              </label>
              <v-menu
                ref="dateStartModal"
                v-model="dateStartModal"
                :close-on-content-click="false"
                :return-value.sync="frmData.dateStart"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- multiple
                  chips
                  small-chips -->
                  <v-combobox
                    v-model="frmData.dateStart"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <!-- multiple -->
                <v-date-picker
                  @input="
                    getResult();
                    dateStartModal = false;
                    $refs.dateStartModal.save(frmData.dateStart);
                  "
                  v-model="frmData.dateStart"
                  no-title
                  scrollable
                >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      frmData.dateStart = '';
                      $refs.dateStartModal.save(frmData.dateStart);
                      dateStartModal = false;
                      getResult();
                    "
                  >
                    الغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>

        <div class="date col-sm-3 col-md-4 col-xxl-3" v-if="dateEnd">
          <div class="select-wrapper">
            <div class="input_wrapper top_label">
              <label for="" class="form-label"> {{ to_title }} </label>
              <v-menu
                ref="dateEndModal"
                v-model="dateEndModal"
                :close-on-content-click="false"
                :return-value.sync="frmData.dateEnd"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- multiple
                  small-chips -->
                  <v-combobox
                    v-model="frmData.dateEnd"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-combobox>
                </template>
                <!-- multiple -->
                <v-date-picker
                  @input="
                    getResult();
                    dateEndModal = false;
                    $refs.dateEndModal.save(frmData.dateEnd);
                  "
                  v-model="frmData.dateEnd"
                  no-title
                  scrollable
                  :min="frmData.dateStart"
                >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      frmData.dateEnd = '';
                      $refs.dateEndModal.save(frmData.dateEnd);
                      dateEndModal = false;
                      getResult();
                    "
                  >
                    الغاء
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </div>

        <div class="categories col-sm-3 col-md-4 col-xxl-3" v-if="brands">
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.brand"
              :options="brandsOptions"
              label="name"
              track-by="id"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getBrand"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.brand") }}
            </label>
          </div>
        </div>

        <div
          class="categories col-sm-6 col-md-4 col-xxl-3"
          v-if="modelsOptions.length"
        >
          <div class="input_wrapper top_label">
            <multiselect
              v-model="frmData.model"
              :options="modelsOptions"
              label="name"
              track-by="id"
              :showLabels="false"
              placeholder=""
              :searchable="true"
              @input="getResult"
            ></multiselect>
            <label for="name_input" class="form-label">
              {{ $t("forms.labels.model") }}
            </label>
          </div>
        </div>

        <div
          class="categories col-sm-6 col-md-4 col-xxl-3"
          v-if="users && clients"
        >
          <div class="select-wrapper">
            <div class="input_wrapper top_label auto_complete">
              <label for="" class="form-label"> المستخدمين </label>

              <v-autocomplete
                v-model="frmData.user"
                :search-input.sync="userKey.input"
                :items="clients"
                item-text="fullname"
                item-value="id"
                placeholder="المستخدمين"
                @input="getResult()"
                :hide-no-data="!clients"
                dense
              ></v-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    searchLabel: {
      type: String,
    },
    numberSeats: {
      type: Boolean,
      default: false,
    },
    numberDoors: {
      type: Boolean,
      default: false,
    },
    brands: {
      type: Boolean,
      default: false,
    },
    madeAt: {
      type: Boolean,
      default: false,
    },
    dateStart: {
      type: Boolean,
      default: false,
    },
    startAt: {
      type: Boolean,
      default: false,
    },
    dateEnd: {
      type: Boolean,
      default: false,
    },
    endAt: {
      type: Boolean,
      default: false,
    },
    withSearch: {
      type: Boolean,
      default: true,
    },
    users: {
      type: Boolean,
      default: false,
    },
    meals_name: {
      type: Boolean,
      default: false,
    },
    orderStatus: {
      type: Boolean,
      default: false,
    },
    place_categories: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    orderStatuses: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    providers: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    providers_title: {
      type: String,
      required: false,
      default: "المزودين",
    },
    from_title: {
      type: String,
      required: false,
      default: "من",
    },
    to_title: {
      type: String,
      required: false,
      default: "الي",
    },
    defaultStartDate: {
      type: String,
      default: "",
    },
    defaultEndDate: {
      type: String,
      default: "",
    },
    defaultStatus: {
      type: [String, Object],
      default: "",
    },
  },

  data() {
    return {
      dateStartModal: false,
      dateEndModal: false,
      dateMadeModal: false,
      frmData: {
        searchInput: "",
        place_category_id: null,
        dateMade: "",
        dateStart: this.defaultStartDate || "",
        dateEnd: this.defaultEndDate || "",
        number_seats: "",
        number_doors: "",
        status: "",
        provider: "",
        meals_name: "",
      },
      userKey: {
        input: "",
        keyword: "",
      },
      brandsOptions: [],
      modelsOptions: [],
      // orderstatusOptions: [
      //   {
      //     text: "محجوزه",
      //     value: "booked",
      //   },
      //   {
      //     text: "مقبولة",
      //     value: "company_accept",
      //   },
      //   {
      //     text: "مدفوعة",
      //     value: "payed",
      //   },
      //   {
      //     text: "في الطريق",
      //     value: "driver_in_the_way",
      //   },
      //   {
      //     text: "بدأت",
      //     value: "company_start",
      //   },
      //   {
      //     text: "انتهت",
      //     value: "company_finished",
      //   },
      // ],
    };
  },

  watch: {
    ["userKey.input"](newVal) {
      if (newVal) {
        this.userKey.keyword = newVal;

        this.getResult();
      }
    },
    ["frmData.dateStart"](newVal) {
      if (newVal) {
        this.getResult();
      }
    },
    ["frmData.dateEnd"](newVal) {
      if (newVal) {
        this.getResult();
      }
    },
    defaultStartDate(newVal) {
      if (newVal) {
        this.frmData.dateStart = newVal;
      }
    },
    defaultEndDate(newVal) {
      if (newVal) {
        this.frmData.dateEnd = newVal;
      }
    },
    defaultStatus() {
      this.syncStatus();
    },
    orderStatuses() {
      this.syncStatus();
    },
    ["$route.query.status"]() {
      this.syncStatus();
    },
    // else {
    //   this.modelsOptions = [];
    //   this.frmData.model = null;
    // }
    // console.log("called");

    // modelsOptions(value) {
    //   if (!value.includes(this.model)) {
    //     this.frmData.model = null;
    //   }
    // },
  },
  mounted() {
    this.syncStatus();
    if (this.$route.query.keyword) {
      this.frmData.searchInput = this.$route.query.keyword;
      // this.getResult()
    }
    if (this.brands) {
      this.$globalService.getBrands().then((res) => (this.brandsOptions = res));
    }
  },
  methods: {
    syncStatus() {
      if (!this.orderStatuses || !this.orderStatuses.length) return;
      const targetVal =
        typeof this.defaultStatus === "object" && this.defaultStatus
          ? this.defaultStatus.value
          : this.defaultStatus || this.$route.query.status;
      if (targetVal) {
        const found = this.orderStatuses.find(
          (item) => item.value == targetVal
        );
        if (found) {
          this.frmData.status = found;
          return;
        }
      }
      this.frmData.status = "";
    },
    getBrand() {
      if (this.frmData.brand) {
        this.$globalService
          .getModels(this.frmData.brand.id)
          .then((res) => (this.modelsOptions = res));
      } else {
        this.modelsOptions = [];
        this.frmData.model = null;
      }
      this.getResult();
    },
    getResult() {
      this.$emit("getResult", this.frmData);
    },

    setKeyWord(event, query) {
      this.frmData.searchInput = event;

      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            [query]: event,
          }),
        })
        .catch(() => {});
    },
    setMealName(event, query) {
      this.frmData.meals_name = event;

      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            [query]: event,
          }),
        })
        .catch(() => {});
    },

    // async get(e) {
    //   await this.$router.push({ query: { keyword: e } });
    //   this.getResult();
    // },
  },

  computed: {
    leaguesTypes() {
      return [
        {
          name: "دوري محلي",
          value: "league",
        },
        {
          name: "دوري ابطال",
          value: "championship",
        },
      ];
    },
    maxDate() {
      const date = new Date();
      return date.toISOString();
    },
  },
};
</script>

<style lang="scss">
.main-filter {
  .frm-controls {
    display: flex;
    flex-wrap: wrap;

    .form-control {
      // background: var(--mainBgColor) !important;
      // color: var(--blackColor) !important;
      border: none;
      height: 45px;
    }

    .v-text-field {
      padding-top: 0;
      margin-top: 0;
      // background: var(--mainBgColor) !important;
      border-radius: 0.375rem;
      align-items: center;
    }
    .v-autocomplete.v-input > .v-input__control > .v-input__slot::before {
      display: none;
    }
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }
  }
  form {
    .form-control {
      width: 100% !important;
    }
    .form-action {
      width: 100% !important;
    }
    min-height: 55px;
  }

  .search-icon {
    color: var(--blackColor) !important;
  }
  .v-text-field__details {
    display: none;
  }

  .v-input__slot {
    margin: 0;
    height: 45px !important;
    box-shadow: none !important;
  }
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: auto !important;
  }
  .row {
    margin: 0;
    > div {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  a.btn {
    background: var(--mainColor-2) !important;
    color: #fff !important;
    height: 45px;
    font-size: 16px;
    line-height: 30px;
  }
  .multiselect__tags {
    height: 45px;
    text-align: start;

    border: none;
    .multiselect__tags-wrap {
      display: flex;
      overflow-x: auto;
    }

    .multiselect__element {
      text-align: start !important;
    }
    .multiselect__single {
      background: var(--mainBgColor);
    }
  }
  .multiselect__content-wrapper {
    background: var(--mainBgColor) !important;
    border: none;
  }

  .v-input input {
    padding: 6px 12px;
    & ~ label {
      right: 6px !important;
    }
  }

  .v-text-field
    > .v-input__control
    > .v-input__slot
    > .v-text-field__slot
    label {
    right: 6px !important;
  }

  .input_wrapper {
    margin-block: 10px !important;
  }
}
</style>
